<template>
  <div class="navbar-container">
    <LogOutModal
      v-if="islogOutAlertActive"
      @confirm="LogOut()"
      @cancel="islogOutAlertActive = false"
    />
    <div class="main-nav">
      <div class="left-nav">
        <div class="QRLogo-container">
          <img
            class="QRLogo"
            @click="ShowNotifications()"
            v-if="isNotificationShow"
            src="../assets/logo-white.png"
            alt="Logo"
          />
          <img
            class="QRLogo"
            @click="ShowNotifications()"
            v-else-if="!isNotificationShow"
            src="../assets/logo-grey.svg"
            alt="Logo"
          />
          <span v-if="unreadNotificationsCounter" class="logo-count-indicator">
            {{ unreadNotificationsCounter }}
          </span>
        </div>
        <div class="nav-link-container">
          <router-link
            to="/orders"
            tag="div"
            class="nav-link"
            active-class="active"
          >
            {{ $t("navbar.orders") }}
            <div class="nav-count-indicator" v-if="pendingCounters.total">
              {{ pendingCounters.total }}
            </div>
          </router-link>
          <router-link
            to="/archive"
            tag="div"
            class="nav-link"
            active-class="active"
            >{{ $t("navbar.archive") }}</router-link
          >

          <router-link
            to="/tables"
            tag="div"
            class="nav-link"
            active-class="active"
            v-if="cafe.modes.inside && !isHotel"
            >{{ $t("navbar.tables") }}</router-link
          >
          <!-- <a
            style="text-decoration: none"
            href="https://t.me/QRWaiterSupportBot"
            target="_blank"
          >
            <div class="nav-link">{{ $t("navbar.support") }}</div>
          </a> -->
        </div>
        <div class="locale-image-div">
          <img
            class="locale-image"
            src="/flags/en.png"
            alt="EN Locale Flag"
            @click="localeShow()"
            v-if="!showLocale && this.$i18n.locale == 'en'"
          />
          <img
            class="locale-image"
            src="/flags/uk.png"
            alt="EN Locale Flag"
            @click="localeShow()"
            v-if="!showLocale && this.$i18n.locale == 'uk'"
          />
          <img
            class="locale-image"
            src="/flags/ru.png"
            alt="EN Locale Flag"
            @click="localeShow()"
            v-if="!showLocale && this.$i18n.locale == 'ru'"
          />
          <div class="otherLocale" v-if="showLocale">
            <img
              class="locale-image"
              src="/flags/en.png"
              alt="EN Locale Flag"
              @click="switchLocale('en'), (showLocale = false)"
            />
            <img
              class="locale-image"
              src="/flags/uk.png"
              alt="UK Locale Flag"
              @click="switchLocale('uk'), (showLocale = false)"
            />
            <img
              class="locale-image"
              src="/flags/ru.png"
              alt="RU Locale Flag"
              @click="switchLocale('ru'), (showLocale = false)"
            />
          </div>
        </div>
      </div>
      <div class="info-container">
        <div class="text-waiter-info">
          <div class="waiter-name">{{ waiter.name }}</div>
          <div class="cafe-name">{{ cafe.name }}</div>
        </div>
        <img
          @click="islogOutAlertActive = true"
          class="waiter-img"
          :src="cafe.image || '/icons/cafe-logo-placeholder.jpg'"
          alt="Image"
        />
      </div>
    </div>
    <div
      :style="`justify-content:${
        [
          'tables',
          'create_order_choose',
          'split_action',
          'merge_action',
          'create_order',
          'move_action',
          'edit_action',
          'create_delivery',
          'create_preorder',
          'create_reserve',
          'edit_preorder',
        ].includes(windowLocate)
          ? 'flex-end'
          : 'space-between'
      }`"
      class="mode-switch-nav"
    >
      <div
        v-if="
          windowLocate == 'archive' ||
          windowLocate == 'orders' ||
          windowLocate == 'create'
        "
        class="modes-list"
      >
        <div
          :class="currentMode == 'inside' ? 'selected-mode mode' : ' mode'"
          @click="emitDesktopNavigate('inside')"
          class="mode"
          v-if="cafe.modes.inside"
        >
          <div>INSIDE</div>
          <div v-if="pendingCounters.inside && windowLocate == 'orders'">
            ({{ pendingCounters.inside }})
          </div>
        </div>
        <div
          :class="currentMode == 'preorder' ? 'selected-mode mode ' : ' mode'"
          @click="emitDesktopNavigate('preorder')"
          class="mode"
          v-if="cafe.modes.preorder"
        >
          <div>TAKEAWAY</div>
          <div v-if="pendingCounters.preorder && windowLocate == 'orders'">
            ({{ pendingCounters.preorder }})
          </div>
        </div>
        <div
          :class="currentMode == 'delivery' ? 'selected-mode mode' : ' mode'"
          @click="emitDesktopNavigate('delivery')"
          class="mode"
          v-if="cafe.modes.delivery"
        >
          <div>DELIVERY</div>
          <div v-if="pendingCounters.delivery && windowLocate == 'orders'">
            ({{ pendingCounters.delivery }})
          </div>
        </div>
        <div
          :class="currentMode == 'reserve' ? 'selected-mode mode' : ' mode'"
          @click="emitDesktopNavigate('reserve')"
          class="mode"
          v-if="cafe.modes.reserve"
        >
          <div>RESERVE</div>
          <div v-if="pendingCounters.reserve && windowLocate == 'orders'">
            ({{ pendingCounters.reserve }})
          </div>
        </div>
        <div
          :class="currentMode == 'hotels' ? 'selected-mode mode' : ' mode'"
          @click="emitDesktopNavigate('hotels')"
          class="mode"
          v-if="cafe.modes.hotels"
        >
          <div>ROOMS</div>
          <div v-if="pendingCounters.hotels && windowLocate == 'orders'">
            ({{ pendingCounters.hotels }})
          </div>
        </div>
      </div>
      <div class="mode-actions">
        <div v-if="isOrderEditMenu && !adding_dish" class="actions-cheque">
          <QueueButton class="confirm navbar-ok-button p-0" @click="emitAction">
            <img src="/icons/ok-new.svg" />
          </QueueButton>
          <QueueButton variant="accept" class="add-dish" @click="discardAction"
            >+ {{ $t("actions.add_dish") }}</QueueButton
          >
        </div>
        <div v-if="action.type == 'goto_order'" class="action-merge-tables">
          <button @click="discardAction()" class="discard-btn">
            <img src="../assets/Arrow.svg" alt />
          </button>
          <button
            @click="emitAction()"
            class="mode-action-btn confirm-btn"
            :style="{ 'background-color': getBtnColor, color: getBtnTextColor }"
            v-if="canStartOrderCreation"
          >
            {{ $t("create_preorder.to_order") }}
          </button>
        </div>
        <div
          v-if="action.type == 'empty' && windowLocate == 'orders'"
          class="action-create-order"
        >
          <button @click="createOrderUi()" class="mode-action-btn create-btn">
            + {{ $t("create_order.confirm") }}
          </button>
        </div>
        <div
          v-if="
            (action.selection ||
              cheksSelected ||
              action.type == 'product-selected' ||
              (cart && !canCreate) ||
              canCreate ||
              action.type == 'split' ||
              addToCart) &&
            action.type != 'create-preorder'
          "
          class="action-merge-tables"
        >
          <button @click="discardAction()" class="discard-btn">
            <img src="../assets/Arrow.svg" alt />
          </button>
          <button
            @click="emitAction()"
            :style="{ 'background-color': getBtnColor, color: getBtnTextColor }"
            class="mode-action-btn confirm-btn"
          >
            {{ getCorrectBtnName }}
          </button>
        </div>
        <div
          v-if="action.type == 'create-preorder'"
          class="action-merge-tables"
        >
          <button @click="discardAction()" class="discard-btn">
            <img src="../assets/Arrow.svg" alt />
          </button>
          <button
            @click="emitAction()"
            v-if="canCreatePreorder"
            class="mode-action-btn confirm-btn"
            :style="{ 'background-color': getBtnColor, color: getBtnTextColor }"
          >
            {{ $t("create_order.confirm") }}
          </button>
          <div class="select-table-text" v-if="!canCreatePreorder">
            <div></div>
            <div>{{ $t("waiting.title") }}</div>
          </div>
        </div>
        <div
          v-if="
            (action.target && !action.selection) ||
            action.type == 'createOrder' ||
            (action.type == 'selectDish' && !cart && !addToCart) ||
            (action.type == 'merge' && !cheksSelected) ||
            (action.type == 'move' && !action.target)
          "
          class="action-select-to-merge"
        >
          <button @click="discardAction()" class="discard-btn">
            <img src="../assets/Arrow.svg" alt />
          </button>
          <div class="select-table-text">
            <div>{{ actionMessage.actionType }}</div>
            <div>{{ actionMessage.actionDescriotion }}</div>
          </div>
        </div>
        <div v-if="windowLocate == 'archive'" class="action-menu-and-date">
          <button @click="toggleSummaryView" class="menu-btn">
            <img
              v-if="!viewingSummary"
              src="../assets/MenuIcon.svg"
              alt="Menu"
            />
            <img
              v-else
              style="width: 3.472vw; height: 3.472vw"
              src="../assets/Cards.svg"
              alt
            />
          </button>
          <span @click="showCalendar = true" class="date-div">
            <select
              class="date-select"
              v-model="selectedDate"
              @input="onDateSelect"
            >
              <option v-for="date in availableDates" :value="date" :key="date">
                {{ date }}
              </option>
            </select>
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="isNotificationShow"
      @click="ShowNotifications()"
      class="background-blur-notifications"
    ></div>
    <div v-if="isNotificationShow" class="notification-container">
      <div class="notification-panel">
        <div v-for="item in notificationsList" :key="item._id">
          <SimpleTextNotification :notification="item" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Polyglote from "@/services/polyglote";
import SimpleTextNotification from "@/components/notifications/SimpleTextNotification.vue";
import moment from "moment";
import LogOutModal from "@/components/modals/LogOutModal.vue";
import QueueButton from "@/components/QueueButton.vue";

export default {
  components: {
    SimpleTextNotification,
    LogOutModal,
    QueueButton,
  },
  props: {
    addToCart: { type: Boolean, default: false },
    adding_dish: { type: Boolean, default: false },
    isOrderEditMenu: { type: Boolean, default: false },
    currentView: { type: String, default: "" },
    canCreate: { type: Boolean, default: false },
    cart: { type: Number, default: 0 },
    cheksSelected: { type: Boolean, default: false },
    canStartOrderCreation: { type: Boolean, default: false },
    canCreatePreorder: { type: Boolean, default: false },
    availableDates: {
      type: Array,
    },
    viewingSummary: { type: Boolean },
    currentMode: {
      type: String,
      default: "none",
    },
    action: {
      type: Object,
      default: () => ({
        present: false,
        type: "empty",
        target: null,
        selection: null,
      }),
    },
  },
  data() {
    return {
      islogOutAlertActive: false,
      showLocale: false,
      isNotificationShow: false,
      selectedDate: "",
    };
  },
  watch: {
    selectedDate() {
      this.onDateSelect();
    },
  },
  mounted() {
    this.selectedDate = moment().format("DD.MM.YYYY");
  },
  methods: {
    LogOut() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    toggleSummaryView() {
      this.$emit("toggleSummaryView");
    },
    onDateSelect() {
      this.$emit("onDateSelect", this.selectedDate);
    },
    createOrderUi() {
      if (this.currentMode == "inside") this.$router.push("/create");
      if (this.currentMode == "preorder") this.$router.push("/create_preorder");
      if (this.currentMode == "delivery") this.$router.push("/create_delivery");
      if (this.currentMode == "reserve") this.$router.push("/create_reserve");
    },
    ShowNotifications() {
      this.isNotificationShow = !this.isNotificationShow;

      if (this.isNotificationShow) {
        this.$store.dispatch("markNotificationsRead");
      }
    },
    discardAction() {
      this.$emit("onDiscardAction", "create");
    },
    emitAction() {
      this.$emit("onConfirmAction");
    },
    emitDesktopNavigate(arg) {
      this.$emit("desktopNavigate", arg);

      if (this.$route.name == "orders") {
        this.$router.replace({
          name: "orders",
          query: {
            m: arg,
          },
        });
      }
    },
    localeShow() {
      this.showLocale = true;
    },
    switchLocale(l) {
      this.$i18n.locale = l;
      moment.locale(this.$i18n.locale);
      Polyglote.updateLocale(l);
      this.showLocale = false;
    },
  },

  computed: {
    windowLocate() {
      let route_name = this.$route.name;

      return route_name;
    },
    actionMessage() {
      switch (this.action.type) {
        case "move":
          return {
            actionType: this.$t("tables.action_messages.move"),
            actionDescriotion: this.$t(
              "tables.action_messages.move_description"
            ),
          };
          break;
        case "join":
          return {
            actionType: this.$t("tables.action_messages.merge"),
            actionDescriotion: this.$t(
              "tables.action_messages.merge_description"
            ),
          };
          break;
        case "merge":
          return {
            actionType: "Об’єднання чеків",
            actionDescriotion: "Оберіть чеки, які Ви хочете об’єднати.",
          };
          break;
        case "createOrder":
          return {
            actionType: this.$t("queue.creating_order_message"),
            actionDescriotion: this.$t("choose_table.title"),
          };
          break;
        case "selectDish":
          return {
            actionType: this.$t("queue.creating_order_message"),
            actionDescriotion: this.$t("add_dish.title"),
          };
          break;
        default:
          break;
      }
    },
    notificationsCounter() {
      return this.$store.getters["reserve/needAttentionCount"];
    },
    unreadNotificationsCounter() {
      return this.$store.getters["unreadNotificationsCount"];
    },
    pendingCounters() {
      let counters = {
        inside: 0,
        preorder: 0,
        delivery: 0,
        reserve: 0,
        total: 0,
      };

      if (!this.cafe || !this.cafe.modes) return counters;

      counters.inside = this.$store.state.queue.orders.filter(
        (o) => o.status === "waiting" || o.status === "paying"
      ).length;
      if (this.cafe.modes.preorder) {
        counters.preorder = this.$store.state.preorder.preorders.filter(
          (o) => !o.is_delivery && o.status === "confirmed"
        ).length;
      }

      if (this.cafe.modes.delivery) {
        counters.delivery = this.$store.state.preorder.preorders.filter(
          (o) => o.is_delivery && o.status === "confirmed"
        ).length;
      }

      counters.reserve = this.$store.state.reserve.list.length;

      counters.total =
        counters.inside +
        counters.preorder +
        counters.delivery +
        counters.reserve;

      return counters;
    },
    getCorrectBtnName() {
      if (this.action.type === "move")
        return `${this.$t("tables.titles.move")}`;
      if (this.action.type === "join")
        return `${this.$t("tables.titles.join")}`;
      if (this.action.type === "merge")
        return `${this.$t("tables.actions.merge")}`;
      if (this.action.type === "split") return `${this.$t("actions.split")}`;
      if (this.action.type === "product-selected")
        return `${this.$t("add_dish.add_to_cart")}`;
      if (
        this.addToCart ||
        (this.cart &&
          this.action.type == "selectDish" &&
          this.currentView == "menu")
      )
        return `${this.$t("add_dish.go_to_cart")} (${this.cart} ${this.$tc(
          "add_dish.dishes_count",
          this.cart
        )})`;
      if (this.canCreate && this.currentView == "cart")
        return `${this.$t("create_order.confirm")}`;
      return "";
    },
    getBtnColor() {
      if (
        this.cart &&
        this.action.type == "selectDish" &&
        this.currentView == "menu"
      )
        return "#AECCC6";
      if (
        (this.action.type === "move" ||
          this.action.type === "merge" ||
          this.action.type === "product-selected" ||
          this.canCreate ||
          this.action.type === "split" ||
          this.action.type == "create-preorder" ||
          this.action.type == "goto_order") &&
        !this.addToCart
      )
        return "#129b81";
      if (this.addToCart) return "#AECCC6";
      if (this.action.type === "join") return "#416293";
    },
    getBtnTextColor() {
      if (
        (this.addToCart || this.cart) &&
        (this.currentView == "menu" || this.currentView == "") &&
        this.action.type == "selectDish"
      )
        return "#1D1D1B";
      else return "#EDEDED";
    },
    cafe() {
      return this.$store.state.cafe;
    },
    waiter() {
      return this.$store.state.waiter;
    },
    notificationsList() {
      return this.$store.state.notifications;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
  },
};
</script>
<style>
@media screen and (max-width: 768px) {
  .navbar-container {
    display: none;
  }
}

/* Main navbar styles */
.navbar-container {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100vw;
}
.main-nav {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 4.167vw;
  background: rgba(29, 29, 27, 0.9);
  backdrop-filter: blur(7px);
}
.left-nav {
  display: flex;
}
.QRLogo-container {
  position: relative;
}
.QRLogo {
  width: 2.083vw;
  height: 2.083vw;
  margin: 1.042vw 4.167vw 0 2.083vw;
}
.logo-count-indicator {
  position: absolute;
  left: 3.681vw;
  top: 0.764vw;
  width: 0.764vw;
  height: 0.764vw;
  background: #e2223b;
  border-radius: 0.069vw;
  color: white;
  font-weight: 500;
  font-size: 0.556vw;
  line-height: 0.625vw;
  padding: 0.069vw 0.208vw;
}
.notification-container {
  position: fixed;
  top: 4.167vw;
  z-index: 10;
  height: 100vh;
}
.background-blur-notifications {
  position: fixed;
  top: 4.167vw;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  -webkit-filter: blur(5px);
  backdrop-filter: blur(5px);
  width: 100vw;
  height: 100vh;
}
.notification-panel {
  height: 95vh;
  z-index: 20;
  width: 26.042vw;
  padding: 1.389vw;

  background: #ededed;
  overflow-y: auto;
}
.notification-panel::-webkit-scrollbar {
  width: 0;
}
.nav-link-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
div.nav-link {
  display: flex;
  align-items: center;
  padding: 0;
  color: #a4a3a1;
  font-weight: 500;
  font-size: 1.389vw;
  line-height: 1.597vw;
  margin-right: 1.389vw;
  cursor: pointer;
}
.nav-link.active {
  color: #ededed;
}
div.nav-count-indicator {
  background: #e2223b;
  border-radius: 0.069vw;
  color: white;
  font-weight: 500;
  font-size: 0.694vw;
  line-height: 1.1;
  text-align: center;
  margin: 0.18vw 0 0 0.556vw;
  padding: 0.069vw 0.278vw;
}
div.locale-image-div {
  align-content: center;
  align-items: center;
  align-self: center;
}
img.locale-image {
  width: 1.667vw;
  height: 1.667vw;
  margin-right: 0.694vw;
}
div.info-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  float: right;
  width: 18.403vw;
  height: 100%;
}
div.cafe-name {
  text-align: right;
  color: #908f8d;
  font-size: 0.972vw;
  line-height: 1.111vw;
}
div.waiter-name {
  text-align: right;
  font-size: 1.25vw;
  line-height: 1.458vw;
  color: #ededed;
}
.waiter-img {
  width: 2.639vw;
  height: 2.639vw;
  object-fit: cover;
  border-radius: 1.319vw;
  margin: 0 2.083vw 0 1.042vw;
}
/* Mode switcher navbar */
.mode-switch-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 9vh;
  background: rgba(70, 70, 70, 0.9);
  backdrop-filter: blur(7px);
}
.modes-list {
  display: flex;
  justify-content: flex-start;
  margin-left: 2.2vh;
}
.mode {
  display: flex;
  height: 4.5vh;
  padding: 1.2vh 2.4vh;
  font-size: 1.7vh;
  cursor: pointer;
  line-height: 1;
  color: #ededed;
  border: 1px solid #ededed;
  border-radius: 5vh;
  margin-right: 1.2vh;
}
.selected-mode {
  border: 1px solid #1d1d1b;
  background: #1d1d1b;
}

.mode div:nth-child(2n) {
  color: #e2223b;
}
div.mode div:first-child {
  margin-right: 0.6vh;
}
div.mode-action {
  width: 26.042vw;
}
.action-create-order {
  margin: 0 2.2vh;
}
.mode-action-btn {
  width: 100%;
  height: 5.5vh;
  border: none;
  border-radius: 5vh;
  padding: 0 3vh;
  color: #ededed;
  font-size: 2vh;
  line-height: normal;
}
.create-btn {
  background: #129b81;
  outline: none !important;
}
.action-merge-tables {
  display: flex;
  align-items: center;
}
button.discard-btn {
  width: 2.917vw;
  height: 2.917vw;
  border: none;
  border-radius: 1.701vw;
  background: #e2223b;
  padding: 0.764vw;
  margin-right: 1.389vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.discard-btn img {
  width: 1.389vw;
  height: 1.389vw;
}
.confirm-btn {
  background: #416293;
  margin-right: 1.389vw;
  outline: none !important;
}
.action-select-to-merge {
  display: flex;
  align-items: center;
}
.select-table-text {
  text-align: center;
  width: 18.958vw;
  color: #908f8d;
  font-size: 0.903vw;
  line-height: 1.042vw;
  margin-right: 1.389vw;
}
.select-table-text div:first-child {
  color: #ededed;
}
.action-menu-and-date {
  display: flex;
  width: 23.264vw;
  align-items: center;
  justify-content: center;
}
.menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.472vw;
  height: 3.472vw;
  background: #ededed;
  border: none;
  border-radius: 1.736vw;
  margin-right: 1.389vw;
}
.menu-btn img {
  width: 1.736vw;
  height: 1.389vw;
}
.menu-btn img:nth-child(2n) {
  width: 3.472vw;
  height: 3.472vw;
}
.date-div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.472vw;
  border: 0.069vw solid #908f8d;
  border-radius: 1.736vw;
  background: #ededed;
  padding: 0.833vw 1.944vw;
  font-size: 1.528vw;
  line-height: 1.736vw;
}
.date-select {
  color: #1d1d1d;
  -webkit-appearance: none;
  outline: none;
  border: none;
  background: transparent;
  text-align: center;
  text-align-last: center;
}
.navbar-ok-button {
  box-shadow: none !important;
}

@media screen and (max-width: 450px) {
  .mode-switch-nav {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .actions-cheque {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.389vw;
    width: 26.042vw;
  }
  button.confirm.p-0.queue-button.variant-cancel img {
    width: 2.917vw;
    height: 2.917vw;
  }
  button.confirm.p-0.queue-button.variant-cancel {
    width: 2.917vw;
    height: 2.917vw;
  }
  button.add-dish.queue-button.variant-accept {
    background: transparent;
    box-shadow: none;
    border: 1px solid #129b81;
    width: 18.958vw;
  }
}
</style>
